import HorizontalLineNode from './HorizontalLineNode'
import HorizontalLineButton from './HorizontalLineButton'
import * as insertExitBlockIfNecessary from '../../slateUtils/insertExitBlockIfNecessary'

const TYPE = 'HorizontalLine'
const TRIGGER_KEY = 'h'

const HorizontalLineSchema = {
  nodes: {
    [TYPE]: HorizontalLineNode
  }
}

const hasHorizontalLine = (state) => {
  const hasBlock = state.blocks.some(node =>
    node.type === TYPE)
  return hasBlock
}

const hasHorizontalLineByKey = (state, key) => {
  const hasBlock = state.blocks.some(node =>
    node.type === TYPE && node.key === key)
  return hasBlock
}

const onKeyDown = (event, data, state) => {
  if (data.isMod && data.key === TRIGGER_KEY) {
    return onApply(state)
  }

  // get this block
  let block
  for (let node of state.blocks) {
    if (node.type === TYPE) {
      block = node
      break
    }
  }

  if (block) {
    let transform = insertExitBlockIfNecessary(block, event, data, state)
    if (transform) {
      return transform.apply()
    }
  }
}

const onClickButton = (e, state) => {
  e.preventDefault()
  return onApply(state)
}

const onApply = state => {
  return state
    .transform()
    .insertBlock({
      type: TYPE,
      isVoid: true,
      data: {}
    })
    .apply()
}

const HorizontalLinePlugin = options => {
  return {
    schema: HorizontalLineSchema,
    onKeyDown (...args) {
      return onKeyDown(...args)
    }
  }
}

export {
  TYPE,
  TRIGGER_KEY,
  hasHorizontalLine,
  hasHorizontalLineByKey,
  onClickButton,
  HorizontalLinePlugin,
  HorizontalLineSchema,
  HorizontalLineNode,
  HorizontalLineButton
}



// WEBPACK FOOTER //
// ./src/components/HorizontalLineSlatePlugin/HorizontalLineSlatePluginContainer.js